<template>
    <div class="recipe-editing">

        <h1 class="text-center">{{ recipe.name }}</h1>

        <div class="row" v-show="!editable">
            <div class="medium-6 columns">

                <h3>
                    Počet porcí: {{ recipe.portions }}
                </h3>

                <h3 style="margin-top: 0.6em;" v-show="recipe.preparation_time">
                    Doba přípravy: {{ recipe.preparation_time }} minut
                </h3>

                <h3  style="margin-top: 0.6em;" v-show="recipe.recipe_source != ''">Zdroj receptu: </h3>
                <div>{{ recipe.recipe_source }}</div>

                <h3 style="margin-top: 1.5em;">
                    Ingredience
                </h3>
                <table>
                    <tr v-for="ingredient in ingredientsStore.state.ingredients">
                        <td style="border-bottom: lightgrey dotted 1px; padding-top: 0.5em;">
                            <span style="display: inline-block; position: relative; background-color: white; top: 1px; padding-right: 0.5em;">{{ ingredient.ingredient.label }}</span>
                        </td>
                        <td align="right" valign="bottom"  style="border-bottom: lightgrey dotted 1px; padding-top: 0.5em;">
                            <span style="display: inline-block; position: relative; background-color: white; top: 1px; padding-left: 0.5em;">
                            {{ ingredient.amount }}
                            {{ ingredientsStore.getIngredientUnitString(ingredient) }}
                            </span>
                        </td>
                    </tr>
                </table>

            </div>
            <div class="medium-6 columns">
                <div v-if="imageSrc && imageSrc !== ''">
                    <img :src="imageSrc" style="margin-bottom: 2em;" >
                </div>

                <h3 style="margin-bottom: 1em;">
                    Příprava
                </h3>

                <div  v-for="(treatment, index) in treatmentsStore.state.treatments" style="margin-bottom: 2em;">
                    <h4>
                        <span class="title-numbering">{{ index + 1 }}</span>
                        {{ treatment.title }}
                    </h4>
                    <p>{{ treatment.description }}</p>
                </div>
            </div>
        </div>

        <bao-ingredients-list
            :image="recipe.image"
            v-show="editable"
        ></bao-ingredients-list>

        <bao-treatments-list
                v-show="editable"
        ></bao-treatments-list>

        <div v-show="editable"
             style="margin-top: 2.5em;"
        >
            <h3>
                <span class="title-numbering">3</span>
                Další informace o receptu
            </h3>

            <p>Zde uveďte počet porcí, pro které je pokrm určen. Můžete také připsat vlastní poznámku či nějaký tip k tomuto receptu (např. v receptu mám nejraději sýr Goudu, přidávám také špetku muškátového oříšku, který není v seznamu ingrediencí kalkulačky).</p>

            <div class="row" style="margin-top: 2em;">
                <div class="small-12 medium-6 columns">

                    <label for="name" class="text-left middle" style="margin-bottom: 0;">Doplňte název receptu:</label>
                    <input id="name" type="text" placeholder="např. Těstoviny se zeleninou" v-model="recipe.name">

                    <div class="row">
                        <div class="small-12 large-6 columns">
                            <label for="portions" class="text-left middle">Počet porcí</label>
                        </div>

                        <div class="small-12 large-6 columns">
                            <div class="input-group">
                                <input class="input-group-field text-center"
                                       type="number"
                                       v-model="recipe.portions"
                                       id="portions"
                                >
                                <span class="input-group-label"
                                      v-tooltip.bottom="{ content:'Zadejte počet porcí receptu' }"
                                >
                                    <i class="fa fa-cutlery"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="small-12 large-6 columns">
                            <label for="portions" class="text-left middle">Čas přípravy</label>
                        </div>
                        <div class="small-12 large-6 columns">
                            <div class="input-group">
                                <input class="input-group-field text-center"
                                       type="number"
                                       v-model="recipe.preparation_time"
                                >
                                <span class="input-group-label"
                                      v-tooltip.bottom="{ content:'Zadejte čas v minutách' }"
                                >
                                        <i class="fa fa-clock-o"></i>
                                        &nbsp;min
                                </span>
                            </div>
                        </div>
                    </div>

                    <label for="source" class="text-left middle" style="margin-bottom: 0;">Doplňte zdroj receptu (nepovinné):</label>
                    <input id="source" type="text" placeholder="např. http://www.mojekucharka.cz/recept nebo rodinný recept" v-model="recipe.recipe_source">

                </div>
                <div class="small-12 medium-6 columns">
                    <label for="description" class="text-left middle" style="margin-bottom: 0;">Níže můžete napsat poznámku k receptu (nepovinné)</label>
                    <textarea id="description" v-model="recipe.description" style="min-height: 300px;" placeholder="např. Na posyp nejraději používám tvrdý kozí sýr."></textarea>
                </div>
            </div>

        </div>

        <div v-show="editable">
            <div class="text-center" style="margin-top: 3em; margin-bottom: 1em;">
                <button class="button large primary" @click="saveRecipe()">VYPOČÍTAT VÝSLEDEK</button>

                <button class="button large primary" @click="saveRecipe(true)" style="margin-left: 1em;" v-show="userId">ULOŽIT RECEPT</button>
            </div>
        </div>

        <div v-show="results.overallImpact">

            <div class="row" id="result">
                <div class="small-12 columns">
                    <h2>Výsledek Nutriční stopy</h2>
                </div>
            </div>

            <p class="text-center"  style="margin-bottom: 1em;" v-html="texts.getText('intro', 'main-graph')"></p>

            <div class="mainPlotLegend row">
                <div class="mainPlotLegend__item small-6 medium-2 medium-push-1 columns">
                    <div class="mainPlotLegend__color level-1"></div>
                    <div class="mainPlotLegend__text">velmi malý dopad</div>
                </div>

                <div class="mainPlotLegend__item small-6 medium-2 medium-push-1 columns">
                    <div class="mainPlotLegend__color level-2"></div>
                    <div class="mainPlotLegend__text">malý dopad</div>
                </div>

                <div class="mainPlotLegend__item small-6 medium-2 medium-push-1 columns">
                    <div class="mainPlotLegend__color level-3"></div>
                    <div class="mainPlotLegend__text">střední dopad</div>
                </div>

                <div class="mainPlotLegend__item small-6 medium-2 medium-push-1 columns">
                    <div class="mainPlotLegend__color level-4"></div>
                    <div class="mainPlotLegend__text">vysoký dopad</div>
                </div>

                <div class="mainPlotLegend__item text-center medium-text-left small-12 medium-2 medium-push-1 end columns">
                    <div class="mainPlotLegend__color level-5"></div>
                    <div class="mainPlotLegend__text">velmi vysoký dopad</div>
                </div>
            </div>


            <div class="row" style="margin-top: 8em;">
                <main-graph
                    :overallImpact="results.overallImpact"
                    :impacts="results.impacts"
                ></main-graph>
            </div>

            <div style="margin-top: 10em; margin-bottom: 1em; font-family: 'Open Sans Condensed', sans-serif;" class="text-center">
                <div class="text-center" style="margin-bottom: 1em; font-weight: bold;">
                    NA 1 PORCI
                </div>
                <indicator-result
                        v-for="(category, indicator) in environmentalBatch"
                        :value="results.totalsPerRation[indicator]"
                        :indicator="indicator"
                        :showIcon="true"
                        :key="indicator"
                        :float="true"
                ></indicator-result>
            </div>

            <div class="text-center" style="margin-top: 3em;" v-show="recipe.summary != ''">
                <h3>Shrnutí výsledku</h3>
                <div class="text-center" v-html="recipe.summary"></div>
            </div>

            <div v-show="!showDetailedResults">
                <div class="text-center" style="margin-top: 5em; margin-bottom: 2em;">
                    <button class="button large primary" @click="showDetailedResults = !showDetailedResults">ZOBRAZIT PODROBNÉ VÝSLEDKY</button>
                </div>
            </div>

            <div v-show="showDetailedResults">

                <div class="row">
                    <div class="small-12 columns">
                        <h2>Životní prostředí</h2>

                        <div class="text-center" style="margin-bottom: 1em; font-weight: bold;">
                            NA 1 PORCI
                        </div>

                        <p class="text-center">Grafy ukazují, jaký podíl dopadu tvoří jednotlivé ingredience a příprava pokrmu pro danou kategorii životního prostředí (ikonka vlevo) z celkové hodnoty dopadu (hodnota vpravo). Čím delší sloupec, tím větší podíl má ingredience či příprava na celkovém dopadu na životní prostředí.</p>

                        <p style="margin-bottom: 2em;" class="text-center"><strong>Pro podrobnosti najeďte na graf myší.</strong></p>
                    </div>
                </div>

                <breakdown-bar v-for="(indicatorShares, label) in environmentalBatch"
                               :indicatorShares="indicatorShares"
                               :label="label"
                               :key="label"
                               :indicatorValue="results.totalsPerRation[label]"
                ></breakdown-bar>

                <div class="row">
                    <div class="small-12 columns">
                        <h2 style="margin-top: 1em;">Výživa a zdraví</h2>

                        <div class="text-center" style="margin-bottom: 1em; font-weight: bold;">
                            NA 1 PORCI
                        </div>

                        <p class="text-center">Grafy ukazují, které ingredience v daném pokrmu obsahují jaké množství energie a látek (tuky, nasycené mastné kyseliny, cukry a sůl), jež mohou být v nadměrném množství rizikové z hlediska výživy a dopadu na zdraví. Čím delší sloupec, tím více dané látky ingredience obsahuje. Zobrazují se jen ingredience a kroky přípravy, které mají vyšší dopad než 10%, zbytek je v kategorii "ostatní".</p>

                        <p style="margin-bottom: 2em;" class="text-center">
                            <strong>Pro podrobnosti najeďte na graf myší.</strong>
                        </p>
                    </div>
                </div>

                <breakdown-bar v-for="(indicatorShares, label) in nutritionBatch"
                               :indicatorShares="indicatorShares"
                               :label="label"
                               :key="label"
                               :indicatorValue="results.totalsPerRation[label]"
                               :shareOfRecommendedIntake="results.sharesOfRecommendedIntake[label]"
                ></breakdown-bar>

            </div>

            <div v-show="!editable">
                <div class="row">
                    <div class="small-12 columns">
                        <h2>Úprava receptu</h2>

                        <p class="text-center">Pro snížení dopadu na životní prostředí či zlepšení výživových hodnot můžete zkusit vyměnit některé ingredience v receptu, nebo snížit jejich množství. Můžete také zkusit změnit typ přípravy pokrmu či zemi původu na lokálnější ingredience dle toho, co je u nás zrovna v sezóně.</p>

                        <p class="text-center" style="margin-bottom: 1em;">
                            <button class="button large primary" @click="editRecipe()">UPRAVIT RECEPT</button>
                        </p>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="small-12 columns">
                    <h2 v-show="!recomended" >Gratulujeme!</h2>
                    <h2 v-show="recomended" >Vyzkoušejte</h2>
                </div>
            </div>

            <div class="row">
                <div class="small-12 columns text-center">

                    <div v-show="!recomended" style="margin: 0 3em; font-size: 1.3em;">
                        Tento recept má pro všechny oblasti životního prostředí ve výpočtu Nutriční stopy velmi malý nebo malý dopad na jednu porci pokrmu. Pro lepší životní prostředí ho tedy můžete pravidelně zařazovat do svého jídelníčku.
                    </div>

                    <div v-show="recomended"  style="margin: 0 3em; font-size: 1.2em;">
                        <p>Tento recept má minimálně v jedné oblasti životního prostředí pro výpočet Nutriční stopy vyšší než malý dopad. Pro lepší životní prostředí proto doporučujeme pravidelně zařazovat do svého jídelníčku také pokrmy, které mají velmi malý či malý dopad pro všechny oblasti životního prostředí. Vyzkoušejte například:</p>

                        <br>

                        <div class="row">
                            <div class="small-12 medium-4 medium-push-4 columns">

                                <a :href="'/edit/' + recomended.id">
                                    <div class="Recipe">
                                        <div class="row">
                                            <div class="small-8 medium-10 large-8 small-push-2 medium-push-1 large-push-2 columns">
                                                <div class="Recipe__plate" style="position:relative;">
                                                    <div class="dimmer" style="position: absolute; z-index: 1; height: 99%; width: 100%; background-position: center; background-size: cover;" :style="{backgroundImage: 'url(' + recomended.image + ')' }">
                                                    </div>
                                                    <div style="z-index: 2;position: relative;">
                                                        <img src="/themes/nutristopa/assets/img/plate.gif" alt="" >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div style="font-size: 1.3em; text-transform: uppercase; font-family: 'Open Sans Condensed', sans-serif;">
                                            {{ recomended.name }}
                                        </div>

                                        <div style=" margin-bottom: 2em;" v-show="false">
                                            <list-result :recipe-id="recomended.id" version="1"></list-result>
                                        </div>

                                    </div>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import _ from 'lodash';

    import BaoIngredientsList from './ingredients-list';
    import BaoTreatmentsList from './treatments-list';
    import ListResult from './list-result';

    import IngredientsStore from '../srores/ingredients-store';
    import TreatmentsStore from '../srores/treatments-store';
    import TextStore from '../srores/text-store';

    import MainGraph from '../charts/MainGraph';
    import BreakdownBar from '../charts/BreakDownBar';
    import IndicatorResult from './indicatorResult';

    import { EventBus } from '../srores/eventBus.js';

    export default {

        'components': {
            BaoIngredientsList,
            BaoTreatmentsList,
            MainGraph,
            Chart,
            BreakdownBar,
            IndicatorResult,
            ListResult
        },

        'props': [
            'id',
            'version',
            'edit'
        ],

        data() {
            return {
                ingredientsStore: IngredientsStore,
                treatmentsStore: TreatmentsStore,
                showTreatments: true,
                showDetails: false,
                showDetailedResults: false,
                recipe: {
                    name: '',
                    description: '',
                    portions: '',
                    recipe_source: '',
                    preparation_time: '',
                    summary: ''
                },
                results: {},
                texts: TextStore,
                recomended: 1,
                userId: false,
                imageSrc: false
            }
        },

        computed: {
            environmentalBatch() {
                if(typeof(this.results.breakdowns) !== 'undefined') {
                    return {
                        climate: this.results.breakdowns['climate'],
                        acidification: this.results.breakdowns['acidification'],
                        euthropication: this.results.breakdowns['euthropication'],
                        occupation: this.results.breakdowns['occupation'],
                        water: this.results.breakdowns['water']
                    }
                }
            },

            nutritionBatch () {
                if(typeof(this.results.breakdowns) !== 'undefined') {
                    return {
                        energy: this.results.breakdowns['energy'],
                        fat: this.results.breakdowns['fat'],
                        fattyacids: this.results.breakdowns['fattyacids'],
                        sugar: this.results.breakdowns['sugar'],
                        salt: this.results.breakdowns['salt']
                    }
                }
            },

            editable () {
                return this.edit;
            }
        },

        mounted() {
            if(this.id) {
                this.showTreatments = true;
                this.showDetails = true;

                this.loadRecipe(this.id);
                this.loadResults(this.id);
            }

            if (this.version == 2) {
                this.showDetailedResults = true;
            }

            setTimeout(() => {
                this.userId = window.userId;
            }, 200);


            // get image url
            this.imageSrc= document.querySelector('#recipeImage').src;

        },

        methods: {
            loadRecipe(id) {
                let vm = this;

                axios.get('/api/recipes/' + id)
                    .then(function (response) {
                        let recipe = response.data.data;

                        console.log(recipe);

                        vm.recipe.name = recipe.name;
                        vm.recipe.description = recipe.description;
                        vm.recipe.portions = recipe.portions;
                        vm.recipe.image = recipe.image;
                        vm.recipe.summary = recipe.summary;
                        vm.recipe.preparation_time = recipe.preparation_time;
                        vm.recipe.recipe_source = recipe.recipe_source;


                        recipe.ingredients.data.forEach(ingredient => {
                            vm.ingredientsStore.addIngredient(ingredient, {
                                unit_id: ingredient.pivot__unit_id,
                                amount: ingredient.pivot__amount,
                                treatment: null
                            })
                        });

                        recipe.treatments.data.forEach(treatment => {
                            vm.treatmentsStore.addLoadedTreatment(treatment);

                            let id = treatment.id;

                            // attaching ingredients to treatments
                            treatment.ingredients.forEach(attached => {
                                let ingredientInStore = _.find(vm.ingredientsStore.state.ingredients, {ingredient: {id: attached}});
                                ingredientInStore.treatment = id;
                            });
                        });

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            isLowImpact() {
                return this.results.impacts.climate <= 2
                    && this.results.impacts.acidification <= 2
                    && this.results.impacts.euthropication <= 2
                    && this.results.impacts.occupation <= 2
                    && this.results.impacts.water <= 2;;
            },

            loadResults(id) {
                let vm = this;

                axios.get('/api/result/' + id)
                    .then(function (response) {

                        vm.results = response.data;

                        // loading recommendation if applicable
                        if(vm.isLowImpact()) {
                            vm.recomended = false;
                        } else {
                            axios.get('/api/recomended/')
                                .then(function (response) {
                                    vm.recomended = response.data;
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            saveRecipe(save = false) {
                let vm = this;

                let data = this.recipe;

                data.ingredients = this.ingredientsStore.state.ingredients;
                data.treatments = this.treatmentsStore.state.treatments;

                data.user_id = window.userId;

                if(save) {
                    data.saved = true;
                }

                axios.post('/api/save/', {data : data})
                    .then(function (response) {
                        var data = response.data;


                        // vm.results = data.data;

                        document.location = '/new/' + data + '#result';

                        //EventBus.$emit('rerender', vm.results.impacts);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            },

            editRecipe() {
                document.location = '/new/' + this.id;
            }

        }
    }
</script>
